<template>
  <app-modal
    v-model="isDialogOpened"
    size="xs"
    :ok-loading="deleteAliasPending"
    :cancel-disabled="deleteAliasPending"
    :ok-text="$t('common.delete')"
    @ok="deleteUserAlias"
    @cancel="closeDialog"
  >
    <template #title>
      {{ $t('profile.views.EmailAlias.deleteAlias', { email: alias.email }) }}
    </template>
    <template #body>
      <p>{{ $t('profile.views.EmailAlias.deleteAliasDialogText') }}</p>
    </template>
  </app-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { DELETE_USER_ALIAS } from '@/store/modules/user/action_types'

export default {
  name: 'EmailAliasDeleteDialog',
  mixins: [dialogMixin],
  props: {
    alias: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['aliases', 'deleteAliasPending']),
  },
  methods: {
    ...mapActions('user', [DELETE_USER_ALIAS]),
    async deleteUserAlias () {
      try {
        await this.DELETE_USER_ALIAS({
          aliasId: this.alias.id,
        })
        const index = this.aliases.findIndex(item => item.id === this.alias.id)
        if (index > -1) {
          this.aliases.splice(index, 1)
        }
        toast.success(this.$t('profile.views.EmailAlias.deleteAliasSuccess', { email: this.alias.email }))
        this.closeDialog()
      } catch (e) {
        toast.error(this.$t('profile.views.EmailAlias.deleteAliasError'))
      }
    },
  },
}
</script>
